module.exports = __webpack_public_path__ + "static/media/gameplay2-en.aaa1832e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/gameplay2-en.png
// module id = 188
// module chunks = 0